import { c as _c } from "react-compiler-runtime";
import { useEffect, useRef, useState } from 'react';
import { useDeepCommentingNavigationMessaging } from '../../messaging/messageHandlers';
export default function useEmbeddedCommentsNavigation(t0) {
  "use memo";

  const $ = _c(12);
  const {
    commentableArea,
    moduleId
  } = t0;
  const highlightTimeoutRef = useRef(undefined);
  const [isHighlightedBySidebar, setIsHighlightedBySidebar] = useState(false);
  let t1;
  if ($[0] !== commentableArea || $[1] !== moduleId) {
    t1 = msg => {
      if (msg.payload.moduleId !== moduleId || !commentableArea) {
        return;
      }
      commentableArea === null || commentableArea === void 0 || commentableArea.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center"
      });
    };
    $[0] = commentableArea;
    $[1] = moduleId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== moduleId) {
    t2 = msg_0 => {
      if (msg_0.payload.moduleId !== moduleId) {
        setIsHighlightedBySidebar(false);
        return;
      }
      if (highlightTimeoutRef.current) {
        clearTimeout(highlightTimeoutRef.current);
      }
      setIsHighlightedBySidebar(true);
      highlightTimeoutRef.current = setTimeout(() => {
        setIsHighlightedBySidebar(false);
      }, 2000);
    };
    $[3] = moduleId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = {
      onRequestScrollToModule: t1,
      onRequestHighlightModule: t2
    };
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useDeepCommentingNavigationMessaging(t3);
  let t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => () => {
      clearTimeout(highlightTimeoutRef.current);
    };
    t5 = [];
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  if ($[10] !== isHighlightedBySidebar) {
    t6 = {
      isHighlightedBySidebar
    };
    $[10] = isHighlightedBySidebar;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}